import { render, staticRenderFns } from "./AdminNewUser.vue?vue&type=template&id=12912932"
import script from "./AdminNewUser.vue?vue&type=script&lang=js"
export * from "./AdminNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports